import { actions } from 'react/api/actions/modals';
import { fromJS } from 'immutable';

const INITIAL_MODAL_STATE = fromJS({
  title: '',
  isOpen: false,
  data: {}
});

const initialState = fromJS({
  logDetails: INITIAL_MODAL_STATE,
  wglnLogDetails: INITIAL_MODAL_STATE,
  localzLogDetails: INITIAL_MODAL_STATE,
  externalStorage: INITIAL_MODAL_STATE,
  dataSyncLogDetails: INITIAL_MODAL_STATE,
  eventDetails: INITIAL_MODAL_STATE,
  shortStopDetails: INITIAL_MODAL_STATE,
  routeAssignments: INITIAL_MODAL_STATE,
  MainSupervisorModal: INITIAL_MODAL_STATE,
  photoAlbum: INITIAL_MODAL_STATE
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.openModal: {
      const { modalKey, title, data } = action.payload;

      return state.setIn([modalKey], fromJS({
        isOpen: true,
        data,
        title
      }));
    }
    case actions.closeModal: {
      const { modalKey } = action.payload;
      return state.setIn([modalKey], INITIAL_MODAL_STATE);
    }
    default:
      return state;
  }
};
